<div *ngIf="buttons$ | async as buttons">
  <div class="facet-buttons" *ngIf="!groupByCategory">
    <hyperkit-tag
    *ngFor="let button of buttons"
    mode="fill"
    [closable]="true"
    [textLeft]="button.category"
    [text]="button.value"
    (click)="onButtonClick(button)"
    >
  </hyperkit-tag>
  </div>
</div>
<div class="button-container" *ngIf="groupByCategory && groupedButtons">
  <div class="button-group" *ngFor="let category of groupedButtons | keyvalue">
    <hyperkit-typography variant="label1" align="left" color="primary">{{category.key}}</hyperkit-typography>
    <div class="facet-buttons">
      <div class="button" *ngFor="let button of category.value">
        <hyperkit-tag
        mode="outline"
        [selected]="button.active"
        [text]="button.value"
        (click)="onButtonClick(button)"
      >
      </hyperkit-tag>
    </div>
    </div>
  </div>
</div>
